import React, { useState, useEffect } from 'react';
import Table from '../../components/Table';
import translations from '../../translations/de';
import Pagination from '../../components/Pagination';
import { useParams } from 'react-router-dom';
import API from './../../api/businessEvents';

const ParticipantsTab = ({ isDisabled = false, className = 'block' }) => {
    const { event_id } = useParams();
    const [participants, setParticipants] = useState([]);
    const [selectedPage, setSelectedPage] = useState(1);
    const [totalPages, setTotalPages] = useState(null);

    useEffect(() => {
        const getParticipants = async () => {
            try {
                const res = await API.getParticipants(event_id, {
                    params: {
                        page: selectedPage,
                        limit: 10,
                    },
                });
                setParticipants(res.data.items);
                setTotalPages(res.data.total_pages_count);
            } catch (e) {
                console.log(e);
            }
        };

        event_id && getParticipants();
    }, [event_id, selectedPage]);

    return (
        <div className={className}>
            {participants.length !== 0 ? (
                <Table
                    tableName={translations.business_profiles}
                    tablePagination={
                        !isDisabled &&
                        totalPages > 1 && (
                            <Pagination
                                totalPages={totalPages}
                                selectedPage={selectedPage}
                                onSelectedPageChange={(selected) => setSelectedPage(selected)}
                            />
                        )
                    }
                    isRowClickable={!isDisabled}
                    columns={[
                        {
                            Header: `ID`,
                            accessor: 'id',
                            Cell: ({ value }) => <div>{value}</div>,
                        },
                        {
                            Header: `${translations.name}`,
                            accessor: 'name',
                            Cell: ({ value }) => <div>{value}</div>,
                        },
                        {
                            Header: `${translations.email}`,
                            accessor: 'email',
                            Cell: ({ value }) => <div>{value}</div>,
                        },
                        {
                            Header: `${translations.partner}`,
                            accessor: 'partner_name',
                            Cell: ({ value }) => <div>{value}</div>,
                        },
                        {
                            Header: 'Partner type',
                            accessor: 'partner_type',
                            Cell: ({ value }) => <div>{value}</div>,
                        },
                        {
                            Header: `${translations.phone}`,
                            accessor: 'phone',
                            Cell: ({ value }) => <div>{value}</div>,
                        },
                    ]}
                    data={participants.map(({ id, name, company, avatar, email, phone }) => {
                        return {
                            id,
                            name,
                            email,
                            partner_name: company?.name,
                            partner_type: company?.type,
                            avatar,
                            phone,
                        };
                    })}
                />
            ) : (
                <div className="no-data">No Data Yet...</div>
            )}
            {}
        </div>
    );
};

export default ParticipantsTab;
